export const ERROR_CODE_PROMO_CODE_INVALID = 3002;
// A promo that joins a community needs the user's first and last name first.
export const ERROR_CODE_NAME_REQUIRED_TO_JOIN = 12074;
